import React from "react";
import { Modal } from "../../../../shared/components/ui/Modal";
import { CreateBuildingForm } from "../CreateBuildingForm/CreateBuildingForm";
import type { CreateBuildingFormValues } from "../CreateBuildingForm/CreateBuildingForm";

interface CreateBuildingModalProps {
  open: boolean;
  onClose: () => void;
  defaultValues: CreateBuildingFormValues;
  onSubmit: (data: CreateBuildingFormValues) => void;
  isSubmitting?: boolean;
  cityOptions: { value: string; label: string }[];
}

export const CreateBuildingModal: React.FC<CreateBuildingModalProps> = ({
  open,
  onClose,
  defaultValues,
  onSubmit,
  isSubmitting,
  cityOptions,
}) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Crear Unidad Residencial"
      // slightly wider modal for more natural form layout
      size="lg"
      className="p-6 sm:p-8"
    >
      <CreateBuildingForm
        defaultValues={defaultValues}
        onSubmit={onSubmit}
        onCancel={onClose}
        isSubmitting={isSubmitting}
        cityOptions={cityOptions}
      />
    </Modal>
  );
};

// Re-export the form values type for convenience
export type { CreateBuildingFormValues };

